import React from "react"
import PropTypes from "prop-types"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import slr36 from "../../assets/images/product/slr36.png"
import com3 from "../../assets/images/product/com.png"


const OrderCancelledModal = props => {
  const { isOpen, toggle, data } = props
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Order Details</ModalHeader>
        <ModalBody>
          <p className="mb-2">
            Product id : <span className="text-primary">{data?.orderId}</span>
          </p>
          <p className="mb-2">
            Billing Name : <span className="text-primary">{data?.billingName}</span>
          </p>
          <p className="mb-2">Status :  <span style={{color: "#f46a6a"}}>Cancelled</span></p>
          <p className="mb-2">
            Reason : <span className="text-primary">Order cancelled due to late expected delivery date</span>
          </p>
          <div className="table-responsive">
            <Table className="table align-middle table-nowrap">
              <thead>
                <tr>
                  <th scope="col">Product</th>
                  <th scope="col">Product Name</th>
                  <th scope="col">Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    <div>
                      <img src={slr36} alt="" className="avatar-sm"/>
                    </div>
                  </th>
                  <td>
                    <div>
                      <h5 className="text-truncate font-size-14">SLR 36</h5>
                      <p className="text-muted mb-0">Rs 65500 x 1</p>
                    </div>
                  </td>
                  <td>Rs 65500</td>
                </tr>
                <tr>
                  <th scope="row">
                    <div>
                      <img src={com3} alt="" className="avatar-sm"/>
                    </div>
                  </th>
                  <td>
                    <div>
                      <h5 className="text-truncate font-size-14">10SA13</h5>
                      <p className="text-muted mb-0">Rs 145000 x 1</p>
                    </div>
                  </td>
                  <td>Rs 145000</td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <h6 className="m-0 text-right">Sub Total:</h6>
                  </td>
                  <td>
                    Rs 210500
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <h6 className="m-0 text-right">Shipping:</h6>
                  </td>
                  <td>
                    Free
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <h6 className="m-0 text-right">Total:</h6>
                  </td>
                  <td>
                    Rs 210500
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

OrderCancelledModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.object,
}

export default OrderCancelledModal
